import styled from 'styled-components'

/**
 * A working surface rather than a page: the list of conversations is a rail
 * on the left, the chat takes the rest. Under 900px the rail moves into a dialog.
 */
export const StyledShell = styled.div`
  display: grid;
  grid-template-columns: 264px minmax(0, 1fr);
  gap: var(--m-spacing-8);
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  @media screen and (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const StyledSidebar = styled.aside`
  min-height: 0;
  max-height: calc(100vh - 128px);
  max-height: calc(100dvh - 128px);
  padding-right: var(--m-spacing-4);
  border-right: var(--m-border-thin) solid rgb(var(--m-color-border));
  overflow-y: auto;
  /* Scrolling to the end of the list must not scroll the page behind it. */
  overscroll-behavior: contain;
  scrollbar-width: thin;

  @media screen and (max-width: 900px) {
    display: none;
  }
`

export const StyledMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--m-spacing-3);
  min-width: 0;
`

export const StyledConversationsButton = styled.button`
  display: none;
  align-self: flex-start;
  align-items: center;
  gap: var(--m-spacing-2);
  padding: var(--m-spacing-2) var(--m-spacing-3);
  border: var(--m-border-thin) solid rgb(var(--m-color-border));
  border-radius: 10px;
  background-color: rgb(var(--m-color-background-primary));
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  font-weight: var(--m-font-weight-medium);
  color: rgb(var(--m-color-primary-100));
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid rgb(var(--m-color-brand));
    outline-offset: 2px;
  }

  @media screen and (max-width: 900px) {
    display: inline-flex;
  }
`
